import React from 'react';
import { Heading } from 'src/components/Form';
import Button from 'src/components/Button';
import Col from 'src/components/Col';
import File from 'src/components/File';
import Input from 'src/components/Input';
import Row from 'src/components/Row';
import { onCheckDocument } from 'src/helpers/CommonHelpers';
import { useCompanySettings } from 'src/pages/Settings/CustomHooks/useCompanySettings';
import LoadState from 'src/components/LoadState/LoadState';
import '../../Settings.scss';

export const CompanySettingsSection: React.FC = () => {
  const {
    settings,
    errors,
    saveClicked,
    isPropertyDeveloper,
    updateField,
    handleSubmit,
    clearSaveState,
    isLoading
  } = useCompanySettings();

  if (!isPropertyDeveloper) return null;

  if (isLoading) {
    return (
      <div className="settingsSection">
        <LoadState isLoading>{null}</LoadState>
      </div>
    );
  }

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await handleSubmit();
  };

  return (
    <form onSubmit={onSubmit}>
      <div className="settingsSection">
        <Heading>Company Settings</Heading>
        <Input
          label="Company Name"
          placeholder="Company Name"
          value={settings.companyName ?? ''}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            updateField('companyName', e.target.value)
          }
          onfocus={clearSaveState}
          block
          errors={errors.companyName}
        />
        <Input
          label="Address"
          placeholder="Address"
          value={settings.companyAddress ?? ''}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            updateField('companyAddress', e.target.value)
          }
          onfocus={clearSaveState}
          block
          errors={errors.companyAddress}
        />
        <Row>
          <Col xs={12} md={4}>
            <Input
              label="City"
              placeholder="City"
              value={settings.companyCity ?? ''}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                updateField('companyCity', e.target.value)
              }
              onfocus={clearSaveState}
              block
              errors={errors.companyCity}
            />
          </Col>
          <Col xs={12} md={4}>
            <Input
              label="State"
              placeholder="State"
              value={settings.companyState ?? ''}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                updateField('companyState', e.target.value)
              }
              onfocus={clearSaveState}
              block
              errors={errors.companyState}
            />
          </Col>
          <Col xs={12} md={4}>
            <Input
              label="Zip"
              placeholder="Zip"
              value={settings.companyZip ?? ''}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                updateField('companyZip', e.target.value)
              }
              onfocus={clearSaveState}
              block
              errors={errors.companyZip}
            />
          </Col>
        </Row>
        <Input
          label="Email"
          placeholder="Email"
          value={settings.companyEmail ?? ''}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            updateField('companyEmail', e.target.value)
          }
          onfocus={clearSaveState}
          block
          errors={errors.companyEmail}
        />
        <Input
          label="Phone"
          placeholder="Phone"
          value={settings.companyPhone ?? ''}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            updateField('companyPhone', e.target.value)
          }
          onfocus={clearSaveState}
          block
          errors={errors.companyPhone}
        />
        <File
          label="Company Logo"
          onSelect={(file: any) =>
            onCheckDocument(file) && updateField('selectedCompanyLogo', file)
          }
          files={settings.selectedCompanyLogo ?? []}
          image={settings.companyLogo}
          type="image"
        />
        <Button
          label="Save Company Settings"
          disabled={saveClicked}
          size="small"
          color="teal"
          submit
        />
      </div>
    </form>
  );
};